import { ChangeOwnPasswordCommand } from '../commands/change-own-password.command';
import { ChangeOwnPasswordContent } from '../commands/payloads/change-own-password-content';
import type { OwnPasswordFormData } from '../components/_forms/own-password-form';
import type { CommandResultBus } from './command-result-bus.interface';

/** What a password save did: saved, or refused by the server (a dispatch that throws included). */
export type OwnPasswordSaveOutcome =
    | { kind: 'saved' }
    | { kind: 'refused'; error: unknown };

/**
 * Saves the section "Passwort ändern": sends `change.own-password` for the user's own uid with the
 * current and the new password; the repetition stays on the page. Kept out of the element so it runs
 * without a DOM.
 *
 * The CommandBus clears both passwords on the payload right after the request body was built; they
 * are cleared here once more after every outcome, a dispatch that throws included, so no path leaves
 * them on the command the bus keeps in its history.
 */
export async function saveOwnPassword(userUid: string, value: OwnPasswordFormData, bus: CommandResultBus): Promise<OwnPasswordSaveOutcome> {
    const content = new ChangeOwnPasswordContent(value.currentPassword, value.newPassword);
    try {
        const result = await bus.dispatchCommandForResult(new ChangeOwnPasswordCommand(userUid, content));

        return result.success ? { kind: 'saved' } : { kind: 'refused', error: result.error };
    } catch (error) {
        return { kind: 'refused', error };
    } finally {
        content.clearSensitiveValues();
    }
}
